// PDF export utilities
// Note: Some bundlers warn about missing source maps for these libs; it's harmless.
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export async function exportElementToPdf(element, filename = 'report.pdf') {
  if (!element) return;
  const A4_WIDTH = 210; // mm
  const A4_HEIGHT = 297; // mm
  const SCALE = 2; // hi-res
  
  // Compute width to keep aspect consistent
  const targetWidthPx = element.clientWidth; // visible width

  const canvas = await html2canvas(element, {
    scale: SCALE,
    useCORS: true,
    logging: false,
    windowWidth: targetWidthPx,
  });
  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF('p', 'mm', 'a4');

  const imgWidthMm = A4_WIDTH;
  const imgHeightMm = (canvas.height / canvas.width) * imgWidthMm;

  // Multi-page render
  let y = 0;
  while (y < imgHeightMm) {
    pdf.addImage(imgData, 'PNG', 0, -y, imgWidthMm, imgHeightMm);
    y += A4_HEIGHT;
    if (y < imgHeightMm) pdf.addPage();
  }

  pdf.save(filename);
}
